import type { SeoLang } from '../site';
import type { Guide } from './types';
import { boatGuide } from './guides/boat';
import { mamanguaGuide } from './guides/mamangua';
import { trindadeGuide } from './guides/trindade';
import { jeepGuide } from './guides/jeep';
import { thingsToDoGuide } from './guides/things-to-do';
import { beachesGuide } from './guides/beaches';

/** Guides in the order menus list them (names and addresses only; the texts are in guideTexts.ts). */
export const GUIDES: Guide[] = [thingsToDoGuide, boatGuide, mamanguaGuide, beachesGuide, trindadeGuide, jeepGuide];

/** A guide from its address in any language (/guia/<slug>); `lang` is the language that slug belongs to. */
export function guideBySlug(slug: string): { guide: Guide; lang: SeoLang } | undefined {
  const target = slug.toLowerCase();
  for (const guide of GUIDES) {
    for (const [lang, copy] of Object.entries(guide.copy) as Array<[SeoLang, Guide['copy'][SeoLang]]>) {
      if (copy.slug === target) return { guide, lang };
    }
  }
  return undefined;
}

export const guidePath = (guide: Guide, lang: SeoLang) => `/guia/${guide.copy[lang].slug}`;

/** Guides that point readers to this tour (shown on the tour page). */
export const guidesForTour = (slug: string) =>
  GUIDES.filter((guide) => guide.tours.some((item) => item.toLowerCase() === slug.toLowerCase()));
